module.exports = __webpack_public_path__ + "img/FO-Logo-Lockup-white.61253f4a.png";